import * as React from "react";
import type { SVGProps } from "react";
const SvgTruncate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M18.5 7v12a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V7M3.5 7h17"
    />
  </svg>
);
export default SvgTruncate;
